<!-- =========================================================================================
  File Name: UserList.vue
  Description: Menu Builder List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div id="page-user-list"> -->

  <div>
    <vs-button
      class="mb-3 ml-auto "
      @click="updateLayout"
      color="primary"
      type="filled"
      icon-pack="feather"
      icon="icon-save"
      >{{ $t('MENU.BUILDER.save_layout') }}</vs-button
    >

    <!-- <vx-card :title="'Construtor de Menu'" save-layout @saveLayoutClicked="updateLayout">

      </vx-card> -->

    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Menu Info" icon-pack="feather" icon="icon-menu">
            <div class="tab-text">
              <menu-builder-form-tab class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";

// Store Module
import draggable from "vuedraggable";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { PlusCircleIcon } from "vue-feather-icons";
import Logo from "../../layouts/components/Logo.vue";
import MenuBuilderFormTab from "./MenuBuilderFormTab.vue";
import {
  getApplicationLocalStorageItem,
  setApplicationLocalStorageItem,
  performFetch
} from "../../helpers";

export default {
  components: {
    vSelect,
    draggable,
    PlusCircleIcon,
    Logo,
    MenuBuilderFormTab,
    MenuBuilderFormTab
  },
  data() {
    return {
      unsavedLayout: false,
      active: false,
      data: null,
      dataTwo: null
    };
  },
  computed: {
    menuToEdit() {
      return this.$store.state.menuBuilder.currentMenuToEdit;
    }
  },
  watch: {
    "$store.state.auth.menu"() {
      document
        .querySelectorAll(".router-link-exact-active.router-link-active")
        .forEach(item => {
          item.classList.remove("router-link-exact-active");
          item.classList.remove("router-link-active");
        });
    }
  },
  methods: {
    dropItem(event) {
      // this.unsavedLayout = true
    },
    dragStart(event) {
      // console.log(event)
    },

    stopLoading() {
      this.$vs.loading.close();
    },
    validLayout() {
      if (
        Object.keys(this.$store.state.menuBuilder.role).length === 0 &&
        this.$store.state.menuBuilder.role.constructor === Object
      ) {
        this.$vs.notify({
          title: "Atenção",
          text: "Selecione um cargo!",
          iconPack: "feather",
          icon: "icon-icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      const menu = document.querySelector(
        ".vs-sidebar--items > div > section > div"
      );

      const menuArr = Array.prototype.slice.call(menu.children);

      if (menuArr.length > 0) {
        let hasHeader = false;

        let invalidFormat = true;

        // menuArr.every((item) => {

        //   if(!hasHeader && item.tagName.toLowerCase() === 'div') {
        //     invalidFormat = false
        //   }

        //     if(!invalidFormat) {

        //       this.$vs.notify({
        //         title: 'Atenção',
        //         text: 'Há itens fora da âncora',
        //         iconPack: 'feather',
        //         icon: 'icon-icon-alert-circle',
        //         color: 'warning'
        //       })

        //       return false
        //     }

        // })

        let menuGroupWhitoutChilds = 0;

        document
          .querySelectorAll("ul.vs-sidebar-group-items > div")
          .forEach(item => {
            if (item.children.length === 0) {
              menuGroupWhitoutChilds += 1;
            }
          });

        if (menuGroupWhitoutChilds >= 2) {
          this.$vs.notify({
            title: "Atenção",
            text: "Um menu do tipo Grupo precisa ter itens anexados",
            iconPack: "feather",
            icon: "icon-icon-alert-circle",
            color: "warning"
          });

          return false;
        }

        // if(document.querySelector('.vs-sidebar--items > div > section > div').children[document.querySelector('.vs-sidebar--items > div > section > div').children.length - 1].tagName.toLowerCase() === 'span') {
        //   this.$vs.notify({
        //     title: 'Atenção',
        //     text: 'Um menu do tipo Âncora precisa ter itens anexados',
        //     iconPack: 'feather',
        //     icon: 'icon-icon-alert-circle',
        //     color: 'warning'
        //   })

        //   return false
        // }

        return invalidFormat;
      } else {
        return true;
      }
    },
    clearEmptyItems() {
      document
        .querySelectorAll(
          ".vs-sidebar--items > div > section > div > div.vs-sidebar-group > ul > div"
        )
        .forEach(groupItem => {
          groupItem.children.forEach(liItem => {
            if (liItem.innerHTML === "<!---->") {
              liItem.remove();
            }
          });
        });
    },
    sortLayout() {
      const menu = document.querySelector(
        ".vs-sidebar--items > div > section > div"
      );

      const indexList = {};

      const menuArr = menu.children;

      if (menuArr.length > 0) {
        menuArr.forEach((item, index) => {
          if (item !== null && item.getAttribute("data-remove") !== "true") {
            if (item.tagName.toLowerCase() === "span") {
              //Âncora

              const anchorObject = {
                menu_hash: item.getAttribute("data-hash"),
                index: index,
                menu_related_items: []
              };

              indexList[item.getAttribute("data-hash")] = anchorObject;
            } else {
              if (item.classList.contains("vs-sidebar--item")) {
                // Item

                const itemObject = {
                  menu_hash: item.getAttribute("data-hash"),
                  index: index,
                  menu_related_items: []
                };

                indexList[item.getAttribute("data-hash")] = itemObject;
              } else {
                // Grupo

                const groupItem = {
                  menu_hash: item.getAttribute("data-hash"),
                  index: index,
                  menu_related_items: []
                };

                this.clearEmptyItems();

                item
                  .querySelector("ul > div")
                  .children.forEach((groupChildItem, groupChildIndex) => {
                    if (groupChildItem.getAttribute("data-remove") !== "true") {
                      if (
                        groupChildItem.tagName.toLowerCase() === "li" &&
                        groupChildItem.querySelector("div") !== null &&
                        groupChildItem
                          .querySelector("div")
                          .classList.contains("vs-sidebar-group")
                      ) {
                        if (
                          groupChildItem
                            .querySelector("div")
                            .classList.contains("vs-sidebar-group")
                        ) {
                          const groupChildElement = groupChildItem.querySelector(
                            "div"
                          );

                          const groupItemChild = {
                            menu_hash: groupChildElement.getAttribute(
                              "data-hash"
                            ),
                            index: groupChildIndex,
                            menu_related_items: []
                          };

                          groupChildElement
                            .querySelector("ul > div")
                            .children.forEach((childItem, childIndex) => {
                              let dataHash =
                                childItem.tagName.toLowerCase() === "li" &&
                                childItem.querySelector("div") !== null
                                  ? childItem
                                      .querySelector("div")
                                      .getAttribute("data-hash")
                                  : childItem.getAttribute("data-hash");

                              if (dataHash) {
                                const itemChild = {
                                  menu_hash: dataHash,
                                  index: childIndex,
                                  menu_related_items: []
                                };

                                groupItemChild["menu_related_items"].push(
                                  itemChild
                                );
                                indexList[itemChild["menu_hash"]] = itemChild;
                              }
                            });

                          groupItem["menu_related_items"].push(groupItemChild);
                          indexList[
                            groupItemChild["menu_hash"]
                          ] = groupItemChild;
                        } else {
                          let dataHash =
                            groupChildItem.tagName.toLowerCase() === "li" &&
                            groupChildItem.querySelector("div") !== null
                              ? groupChildItem
                                  .querySelector("div")
                                  .getAttribute("data-hash")
                              : groupChildItem.getAttribute("data-hash");

                          if (dataHash) {
                            const item = {
                              menu_hash: dataHash,
                              index: groupChildIndex,
                              menu_related_items: []
                            };

                            groupItemChild["menu_related_items"].push(item);
                            indexList[item["menu_hash"]] = item;
                          }
                        }
                      } else {
                        let dataHash =
                          groupChildItem.tagName.toLowerCase() === "li" &&
                          groupChildItem.querySelector("div") !== null
                            ? groupChildItem
                                .querySelector("div")
                                .getAttribute("data-hash")
                            : groupChildItem.getAttribute("data-hash");

                        if (dataHash) {
                          const item = {
                            menu_hash: dataHash,
                            index: groupChildIndex,
                            menu_related_items: []
                          };

                          groupItem["menu_related_items"].push(item);
                          indexList[item["menu_hash"]] = item;
                        }
                      }
                    }
                  });

                indexList[item.getAttribute("data-hash")] = groupItem;
              }
            }
          }
        });

        this.$store.commit("auth/SORT_MENU_LIST", indexList);

        this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", true);
      }
    },
    async updateLayout() {
      if (!this.validLayout()) return;

      this.sortLayout();

      // return

      this.$vs.loading({ type: "default" });

      const menuList = [];

      const menuArr = this.$store.state.auth.menuLayout;

      if (menuArr.length > 0) {
        menuArr.forEach(item => {
          const itemLevel1Object = {};

          if (!item.hasOwnProperty("remove") || item.remove === false) {
            itemLevel1Object["menu_hash"] = item.hash;
            (itemLevel1Object["menu_name"] = item.header),
              (itemLevel1Object["menu_related_items"] = []);

            if (item.hasOwnProperty("items")) {
              item.items.forEach(itemLevel2 => {
                const itemLevel2Object = {};

                if (
                  !itemLevel2.hasOwnProperty("remove") ||
                  itemLevel2.remove === false
                ) {
                  itemLevel2Object["menu_hash"] = itemLevel2.hash;
                  itemLevel2Object["menu_name"] = itemLevel2.name;
                  itemLevel2Object["menu_related_items"] = [];

                  if (itemLevel2.hasOwnProperty("submenu")) {
                    itemLevel2.submenu.forEach(itemLevel3 => {
                      const itemLevel3Object = {};

                      if (
                        !itemLevel3.hasOwnProperty("remove") ||
                        itemLevel3.remove === false
                      ) {
                        itemLevel3Object["menu_hash"] = itemLevel3.hash;
                        itemLevel3Object["menu_name"] = itemLevel3.name;
                        itemLevel3Object["menu_related_items"] = [];

                        if (itemLevel3.hasOwnProperty("submenu")) {
                          itemLevel3.submenu.forEach(itemLevel4 => {
                            const itemLevel4Object = {};
                            if (
                              !itemLevel4.hasOwnProperty("remove") ||
                              itemLevel4.remove === false
                            ) {
                              itemLevel4Object["menu_hash"] = itemLevel4.hash;
                              itemLevel4Object["menu_name"] = itemLevel4.name;
                              itemLevel4Object["menu_related_items"] = [];

                              itemLevel3Object["menu_related_items"].push(
                                itemLevel4Object
                              );
                            }
                          });

                          itemLevel2Object["menu_related_items"].push(
                            itemLevel3Object
                          );
                        } else {
                          itemLevel2Object["menu_related_items"].push(
                            itemLevel3Object
                          );
                        }
                      }
                    });

                    itemLevel1Object["menu_related_items"].push(
                      itemLevel2Object
                    );
                  } else {
                    itemLevel1Object["menu_related_items"].push(
                      itemLevel2Object
                    );
                  }
                }
              });
            }
          }

          menuList.push(itemLevel1Object);
        });
      }

      try {
        // fetch(`${this.$store.state.auth.api_url}`, {
        //   method: "POST", headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: "update_mainmenu_layout",
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token,
        //       role_hash: this.$store.state.menuBuilder.role.hash,
        //       mainmenu_layout: menuList
        //     }
        //   })
        // })
        await performFetch(`${this.$store.state.auth.api_url}`, {
            command: "update_mainmenu_layout",
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              role_hash: this.$store.state.menuBuilder.role.hash,
              mainmenu_layout: menuList
            }
          })
          .then(async response => {
            if (response.status === 200) {
              document
                .querySelectorAll(
                  ".router-link-exact-active.router-link-active"
                )
                .forEach(item => {
                  item.classList.remove("router-link-exact-active");
                  item.classList.remove("router-link-active");
                });

              // await fetch(`${this.$store.state.auth.api_url}`, {
              //   method: "POST", headers: {"Content-Type": "application/json"},
              //   body: JSON.stringify({
              //     command: "get_application_user_mainmenu",
              //     parameters: {
              //       application_token: this.$store.state.auth.app_token,
              //       session_token: this.$store.state.auth.token
              //     }
              //   })
              // })
              await performFetch(this.$store.state.auth.api_url, {
                  command: "get_application_user_mainmenu",
                  parameters: {
                    application_token: this.$store.state.auth.app_token,
                    session_token: this.$store.state.auth.token
                  }
                })
                .then(async response => {
                  if (response.status === 200) {
                    response.json().then(async responseData => {
                      const mainMenu = responseData.mainmenu;

                      console.log(mainMenu);

                      const mainMenuFormatted = await this.$store.dispatch(
                        "auth/buildApplicationMenu",
                        mainMenu
                      );

                      if (
                        this.$store.state.menuBuilder.role.hash ===
                        JSON.parse(getApplicationLocalStorageItem("role"))
                          .identification
                      ) {
                        setApplicationLocalStorageItem(
                          "currentUserMenu",
                          JSON.stringify(mainMenuFormatted)
                        );
                      }

                      this.$vs.loading.close();

                      this.$vs.notify({
                        title: "Operação Realizada!",
                        text: `Layout atualizado com sucesso!`,
                        iconPack: "feather",
                        icon: "icon-success-circle",
                        color: "success"
                      });

                      this.$vs.loading.close();

                      this.$store.commit(
                        "menuBuilder/SET_UNSAVED_LAYOUT",
                        false
                      );

                      let homeUrl = JSON.parse(
                        getApplicationLocalStorageItem("role")
                      )["home_url"];

                      this.$router.push(homeUrl);
                    });
                  } else if (response.status == 401) {
                    setApplicationLocalStorageItem(
                      "lastUrl",
                      btoa(window.location.pathname)
                    );
                    this.$store.dispatch("auth/signOut");
                    console.log(401);
                  } else {
                    console.log(500);
                  }
                })
                .catch(e => {
                  console.log(e);
                  this.$vs.loading.close();
                });
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
              console.log(401);
            } else {
              console.log(500);
            }
          })
          .catch(e => {
            console.log(e);
            this.$vs.loading.close();
          });
      } catch (e) {
        console.log(e);
      }
    },
    async getParameters() {}
  },
  mounted() {
    this.$store.commit("menuBuilder/SET_UNSAVED_LAYOUT", false);

    document
      .querySelectorAll(".router-link-exact-active.router-link-active")
      .forEach(item => {
        item.classList.remove("router-link-exact-active");
        item.classList.remove("router-link-active");
      });

    // <div class="vs-sidebar--background"></div>

    // document.querySelectorAll('.vx-card__body')[0].style.padding = "0.75rem"
  },
  created() {
    this.getParameters();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/sidebar.scss";

.menu-title {
  font-size: 11px;
  margin-left: 5px;
  font-weight: 500;
  text-transform: uppercase;
  color: #999;
}
</style>
